import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../config/environments/environment';
import { Arrival } from '../../models/dto/arrival/arrival';
import { GatesMonitorDto } from '../../models/dto/arrival/gates-monitor.dto';
import { ReleaseChildren } from '../../models/dto/arrival/gates-monitoring/release-children.dto';

@Injectable()
export class GatesMonitoringService {

  private readonly gatesMonitoringPath = 'gates/monitoring';
  private readonly gatesMonitoringArrival = 'arrivals';
  private readonly releaseChildren = 'release';

  constructor(private http: HttpClient) {}

  getByGateId(id: string, status: string): Observable<GatesMonitorDto[]> {
    return this.http
      .get<GatesMonitorDto[]>
      (`${environment.api.baseUrl}/${this.gatesMonitoringPath}/${id}?status=${status}`)
      .pipe((response) => response)
  }

  getArrivalById(id: string): Observable<Arrival>{
    return this.http.get<Arrival>
    (`${environment.api.baseUrl}/${this.gatesMonitoringArrival}/${id}`)
      .pipe((response) => response)
  }

  updateArrivalById(id: string, arrival: Arrival): Observable<Arrival>{
    return this.http.put<Arrival>
    (`${environment.api.baseUrl}/${this.gatesMonitoringArrival}/${id}`, arrival)
      .pipe((response) => response)
  }

  updateArrivalReleaseChildren(id: string, arrival: ReleaseChildren): Observable<Arrival>{
    return this.http.patch<Arrival>
    (`${environment.api.baseUrl}/${this.gatesMonitoringArrival}/${id}/${this.releaseChildren}`, arrival)
      .pipe((response) => response)
  }
}
